var _metadata, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "452.000000pt",
    height: "452.000000pt",
    viewBox: "0 0 452.000000 452.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,452.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M988 4249 c-26 -4 -70 -20 -98 -35 -123 -67 -428 -340 -530 -475 -88 -118 -93 -132 -87 -269 21 -424 310 -959 860 -1590 133 -152 601 -620 752 -751 629 -547 1160 -834 1582 -856 111 -6 113 -6 175 25 121 60 333 268 503 493 83 110 107 170 106 265 0 51 -6 75 -28 116 -26 47 -47 64 -368 277 -187 125 -383 255 -436 289 -183 118 -242 109 -597 -93 -73 -41 -137 -75 -144 -75 -39 0 -333 255 -593 515 -258 258 -515 554 -515 593 0 7 39 81 87 165 112 198 142 262 153 334 17 105 11 118 -301 588 -271 408 -288 431 -335 456 -56 30 -118 40 -186 28z m94 -201 c31 -24 538 -802 538 -825 0 -41 -35 -115 -159 -333 -142 -251 -141 -213 -18 -376 131 -173 265 -322 507 -564 294 -294 548 -513 685 -589 l40 -23 239 136 c297 168 295 168 408 95 206 -131 714 -473 726 -488 20 -24 8 -83 -26 -133 -101 -145 -373 -428 -450 -467 -51 -26 -109 -27 -227 -2 -418 89 -941 424 -1535 983 -738 694 -1224 1382 -1331 1883 -35 169 -26 207 80 330 98 113 371 350 432 374 34 14 73 13 91 -1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.f9cf208739415364258d5c0062c6d9bb.svg";
export { ForwardRef as ReactComponent };